import { makeStyles } from '@material-ui/styles';

import { toolbarMinHeight } from '../../service/constants';

const DRAWER_WIDTH = 270;

export const useStyles = makeStyles((theme) => {
    return {
        drawerClass: {
            flexShrink: 0,
            zIndex: '999 !important',
            whiteSpace: 'nowrap',
        },
        drawerOpenClass: {
            width: DRAWER_WIDTH,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerCloseClass: {
            width: theme.spacing(7),
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        drawerPaddingBottom: {
            paddingBottom: toolbarMinHeight,
        },
        drawerPaper: {
            overflowX: 'hidden',
        },
        icon: {
            top: '0px',
        },
        listItemText: {
            '& span': {
                fontSize: '18px',
            },
        },
        toolbar: theme.mixins.toolbar,
        simple: {
            fontSize: '18px',
            lineHeight: '18px',
            userSelect: 'none',
        },
        listIcon: {
            minWidth: '40px',
        },
    };
});
